<template>
  <svg width="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.75 1C12.75 0.585786 12.4142 0.25 12 0.25C11.5858 0.25 11.25 0.585786 11.25 1H12.75ZM11.25 15C11.25 15.4142 11.5858 15.75 12 15.75C12.4142 15.75 12.75 15.4142 12.75 15H11.25ZM11.25 1V15H12.75V1H11.25Z" fill="currentColor"></path>
    <circle opacity="0.4" cx="12" cy="13" r="9" fill="currentColor"></circle>
  </svg>
</template>
